import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Container from '~/components/ui/Container';
import { Link } from '~/components/ui/Link';
import { textContent } from '~/pages/Tools/CalculateMaximumMortgage/Index/data';

type IndexCallToActionSectionProps = {
  totalOffices: number;
};

const IndexCallToActionSection: React.FC<IndexCallToActionSectionProps> = ({
  totalOffices,
}) => {
  const { callToAction } = textContent;

  return (
    <section className="bg-white py-14">
      <Container>
        <h2 className="mb-8 text-center font-display text-xl font-bold text-blue-600 md:text-3xl">
          {callToAction.title}
        </h2>

        <p className="whitespace-pre text-wrap text-center">
          {callToAction.getContent(totalOffices)}
        </p>

        <div className="flex justify-center pt-4">
          <Link href={callToAction.link}>
            {callToAction.buttonTitle}
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default IndexCallToActionSection;
